/**
 * Subscription State Management (Simplified)
 *
 * 【重要】2025/10/01変更: Shopifyメタフィールド中心の設計に変更
 * - クレジット情報はShopifyメタフィールドから直接取得（Liquid変数）
 * - このファイルは後方互換性のために残すが、実際の情報源はShopify
 * - ダウンロード時のクレジット消費はShopify APIで直接更新
 */

(function() {
  'use strict';

  // 後方互換性のために最小限の実装を残す
  window.SubscriptionState = {
    initialized: true,
    loading: false,

    // Shopify Liquidから設定された値を使用
    get hasSubscription() {
      // window.customerが存在し、かつidがあればログイン済み
      // クレジット情報が設定されていればサブスクあり
      if (!window.customer || !window.customer.id) {
        return false; // ログインしていない
      }

      // hasSubscriptionが明示的に設定されていればそれを使用
      if (window.customer.hasSubscription !== undefined) {
        return window.customer.hasSubscription === true;
      }

      // 後方互換性: creditsRemainingが定義されていればサブスクあり
      return window.customer.creditsRemaining !== undefined && window.customer.creditsRemaining !== null;
    },

    get creditsRemaining() {
      return window.customer?.creditsRemaining || 0;
    },

    // クレジット消費（ローカル表示更新のみ）
    consumeCredit: function(amount = 1) {
      if (window.customer && window.customer.creditsRemaining >= amount) {
        window.customer.creditsRemaining -= amount;

        // 表示を更新
        if (window.updateCreditsDisplay) {
          window.updateCreditsDisplay(window.customer.creditsRemaining);
        }

        return true;
      }
      return false;
    },

    // ページリロード（サーバーから最新値を取得）
    refresh: function() {
      window.location.reload();
    },

    // 後方互換性のためのダミー関数
    on: function() {},
    emit: function() {},
    fetch: function() {},
    sync: function() {},
    init: function() {}
  };

  // 初期化ログは遅延実行（window.customerが確実に設定された後）
  // DOMContentLoadedではなく、window.onloadを使用
  if (document.readyState === 'complete') {
    // 既にロード完了済みなら即座に実行
    setTimeout(function() {
    }, 100); // 100ms遅延で確実にcredits-displayの後に実行
  } else {
    // ロード完了を待つ
    window.addEventListener('load', function() {
      setTimeout(function() {
      }, 100);
    });
  }

})();
